// extracted by mini-css-extract-plugin
export default {"animatedText":"AnimatedText_animatedText__CSm3V"};